/*
 * Copyright (c) All right reserved Anvish Inc. 2025
 * This project and any portion thereof may not be reproduced or used in any manner without the express written permission of Anvish Inc.
 */
"use client";
import React from "react";
import { Button, ButtonProps } from "@heroui/button";
import { useRouter } from "next/navigation";

interface AXButtonProps extends ButtonProps {
  title: string;
  link?: string;
  onPress?: () => void;
  className?: string;
}

const AXButton: React.FC<AXButtonProps> = ({
  title,
  link,
  onPress,
  className,
  ...props
}) => {
  const router = useRouter();

  return (
    <Button
      className={`bg-ax-primary text-ax-text-color font-medium ${className}`}
      onPress={onPress ? onPress : link ? () => router.push(link) : undefined}
      {...props}
    >
      {title}
    </Button>
  );
};

export default AXButton;
